import { IDropdown } from '@app/shared/interfaces/dropdown';

export enum RELIGION {
  'Buddhism' = 1,
  'Other religions and spiritual traditions' = 2,
  'Christianity' = 3,
  'No religion and secular perspectives' = 4,
  'Hinduism' = 5,
  'Judaism' = 6,
  'Islam' = 7,
  'Sikhism' = 8,
  'Traditional (North American Indigenous) spirituality' = 9,
  'Not sure' = 10,
}


export const RELIGION_DROPDOWN: IDropdown<string>[] = Object.values(RELIGION)
  .filter((value) => isNaN(Number(value)) === true)
  .map((value) => ({ value: `${RELIGION[value]}`, label: value } as IDropdown<string>));
